import { PropertyResponseDto } from "@/common/api/datasources/Api";

interface DocumentsTabProps {
    property: PropertyResponseDto;
}

export const DocumentsTab = ({ property }: DocumentsTabProps) => {
    return (
        <div className="space-y-4">
            <div className="rounded-lg shadow p-6">
                <h2 className="text-xl font-semibold mb-4">Документи</h2>
                <p className="text-muted-foreground">Тут буде відображатись інформація про документи, пов'язані з цією нерухомістю.</p>
            </div>
        </div>
    );
}; 